var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "sidebar-wrapper",
      class: { collapsed: _setup.isCollapsed },
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("img", {
          attrs: {
            src: _setup.isCollapsed
              ? _setup.CustomilyLogo
              : _setup.CustomilyFullLogo,
            alt: "customily-logo",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "collapse-toggle",
          class: { collapsed: _setup.isCollapsed },
          attrs: {
            type: "button",
            "aria-label": _setup.isCollapsed
              ? "Expand sidebar"
              : "Collapse sidebar",
          },
          on: { click: _setup.toggleCollapsed },
        },
        [_c("font-awesome-icon", { attrs: { icon: ["far", "left-to-line"] } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._l(_setup.sections, function (section, idx) {
            return [
              !section.hidden
                ? _c(
                    "section",
                    {
                      key: `section-${section.name}-${idx}`,
                      staticClass: "nav-section",
                    },
                    [
                      section.name?.length
                        ? _c("div", { staticClass: "section-title" }, [
                            _vm._v(_vm._s(section.name)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(section.items, function (item) {
                        return _c(_setup.SidebarMenuItem, {
                          key: item.name,
                          attrs: {
                            item: item,
                            collapsed: _setup.isCollapsed,
                            expanded: _setup.expandedItem === item.name,
                            "active-route": _vm.activeRoute,
                          },
                          on: {
                            toggle: _setup.onToggle,
                            navigate: _setup.onNavigate,
                          },
                        })
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-section mt-auto" },
            [
              _c(_setup.SidebarUserCard, {
                attrs: {
                  collapsed: _setup.isCollapsed,
                  "has-accounts-to-impersonate": _vm.hasAccountsToImpersonate,
                },
                on: {
                  impersonate: function ($event) {
                    return _setup.emit("impersonate")
                  },
                  "impersonate-child": function ($event) {
                    return _setup.emit("impersonate-child")
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_setup.accountSection, function (item) {
                return _c(_setup.SidebarMenuItem, {
                  key: item.name,
                  attrs: {
                    item: item,
                    "active-route": _vm.activeRoute,
                    collapsed: _setup.isCollapsed,
                    expanded: _setup.expandedItem === item.name,
                  },
                  on: { toggle: _setup.onToggle, navigate: _setup.onNavigate },
                })
              }),
            ],
            2
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }